import {FunctionComponent, PropsWithChildren, useCallback, useContext, useState} from 'react';
import {SharedBackdropContext} from './shared-backdrop-context';

export const SharedBackdropProvider: FunctionComponent<PropsWithChildren> = ({children}) => {
  const [count, setCount] = useState(0);

  const register = useCallback((): (() => void) => {
    setCount(c => c + 1);
    return () => setCount(c => c - 1);
  }, []);

  return <SharedBackdropContext.Provider value={{register, count}}>{children}</SharedBackdropContext.Provider>;
};

export const SharedBackdrop: FunctionComponent = () => {
  const {count} = useContext(SharedBackdropContext);

  if (count === 0) return null;

  return <div className="fixed inset-0 z-50 animate-fade-in bg-black/30" />;
};
